import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=50c6b846"
import script from "./TabNavigation.vue?vue&type=script&lang=js"
export * from "./TabNavigation.vue?vue&type=script&lang=js"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=50c6b846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports